// extracted by mini-css-extract-plugin
export var card = "_95-1";
export var container = "_95-0";